<template>
  <v-container>
    <v-card>
      <v-row align="center" class="py-1 px-2" no-gutters>
        <v-col cols="12" sm="6">
          <v-breadcrumbs class="px-2" :items="breadcrumbsItems"></v-breadcrumbs>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          :class="$store.getters.LANGUAGE == 'fa' ? 'text-left' : 'text-right'"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                small
                class="mx-2"
                v-bind="attrs"
                v-on="on"
                color="orange"
                @click="helpDialog = true"
              >
                <v-icon small>fa-question</v-icon>
              </v-btn>
            </template>
            <span>{{ $vuetify.lang.translator("showHelp") }}</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <v-row class="mt-2">
        <v-col cols="12" sm="3">
          <v-text-field
            v-model="search"
            :label="$vuetify.lang.translator('searchFolderName')"
            clearable
            class="mx-2"
          ></v-text-field>
          <v-treeview
            :active.sync="active"
            :items="parents"
            :load-children="fetchChildren"
            :open.sync="open"
            :search="search"
            :filter="filter"
            item-key="id"
            activatable
            open-on-click
            transition
            class="mx-2"
          >
            <template v-slot:prepend="{ item, open }">
              <v-icon>
                {{ open ? "far fa-folder-open" : "far fa-folder" }}
              </v-icon>
            </template>
          </v-treeview>
        </v-col>

        <v-divider vertical></v-divider>

        <v-col v-if="showExtra">
          <v-progress-linear
            indeterminate
            v-if="loadingExtra"
          ></v-progress-linear>
          <v-row>
            <v-col>
              <v-card>
                <v-img height="400" contain :src="tower_image"></v-img>
                <v-card-actions>
                  <div>{{ $vuetify.lang.translator("towerView") }}</div>
                  <v-spacer></v-spacer>
                  <v-btn @click="towerDialog = true">{{
                    $vuetify.lang.translator("update")
                  }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col>
              <v-card>
                <v-img height="400" contain :src="tower_type_image"></v-img>
                <v-card-actions>
                  <div>{{ $vuetify.lang.translator("towerType") }}</div>
                  <v-spacer></v-spacer>
                  <v-btn @click="openChangeTowerType()">{{
                    $vuetify.lang.translator("update")
                  }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-else>
          <v-tabs fixed-tabs v-model="tab">
            <v-tab
              >{{ $vuetify.lang.translator("imagesWithError") }} ({{
                imagesWithError.length
              }})</v-tab
            >
            <v-tab
              >{{ $vuetify.lang.translator("imagesWithoutError") }} ({{
                imagesWithNoError.length
              }})</v-tab
            >
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-row class="my-1" v-if="imagesWithError.length === 0">
                <v-col>
                  <v-progress-linear
                    indeterminate
                    v-if="loadingImages"
                  ></v-progress-linear>
                  {{ $vuetify.lang.translator("selectAFolder") }}
                </v-col>
              </v-row>
              <v-row class="my-1" v-else>
                <v-col
                  v-for="(item, i) in imagesWithError"
                  :key="i"
                  cols="12"
                  lg="6"
                  xl="4"
                >
                  <v-card>
                    <v-img
                      :src="item.small"
                      :lazy-src="item.small"
                      @click="showFullSize(item.name, item.id)"
                      style="cursor: zoom-in;"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-row>
                        <v-col class="text-center"
                          ><v-chip color="yellow"
                            >{{ $vuetify.lang.translator("normal") }}
                            {{ item.normal_count }}</v-chip
                          ></v-col
                        >
                        <v-col class="text-center"
                          ><v-chip color="orange"
                            >{{ $vuetify.lang.translator("warning") }}
                            {{ item.warning_count }}</v-chip
                          ></v-col
                        >
                        <v-col class="text-center"
                          ><v-chip color="red"
                            >{{ $vuetify.lang.translator("critical") }}
                            {{ item.critical_count }}</v-chip
                          ></v-col
                        >
                      </v-row>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item>
              <v-row class="my-1" v-if="imagesWithNoError.length === 0">
                <v-col>
                  {{ $vuetify.lang.translator("selectAFolder") }}
                </v-col>
              </v-row>
              <v-row class="my-1" v-else>
                <v-col
                  v-for="(item, i) in imagesWithNoError"
                  :key="i"
                  cols="12"
                  lg="6"
                  xl="4"
                >
                  <v-card>
                    <v-img
                      :src="item.small"
                      :lazy-src="item.small"
                      @click="showFullSize(item.name, item.id)"
                      style="cursor: zoom-in;"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                    <v-divider></v-divider>
                  </v-card>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-card>

    <v-dialog
      v-model="fullSizeDialog"
      persistent
      max-width="1264"
      @keydown.esc="fullSizeDialog = false"
    >
      <v-card>
        <v-toolbar>
          <v-toolbar-title>{{ fullSizeTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="fullSizeDialog = false">
              <v-icon>fa-times</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container fluid>
          <v-row dense>
            <v-col cols="12" lg="7">
              <v-data-table
                fixed-header
                :header-props="{ sortIcon: 'fas fa-sort-amount-up-alt' }"
                :headers="headers"
                :items="items"
                :loading="loading"
                sort-by="updated_at"
                :sort-desc="true"
                :items-per-page="itemsPerPage"
                @update:items-per-page="updateRecordsPerPage"
                :footer-props="{ itemsPerPageOptions: [10, 25, 50, 100] }"
                :options.sync="options"
                :server-items-length="totalItems"
                :dense="showDense"
                :caption="$vuetify.lang.translator('errorsList')"
                class="elevation-2"
              >
                <template v-slot:item.index="{ item }">
                  {{
                    (options.page - 1) * options.itemsPerPage +
                      items.indexOf(item) +
                      1
                  }}
                </template>
                <template v-slot:item.x1="{ item }">
                  <div class="ltr-text">
                    {{ item.x1 }}, {{ item.y1 }}
                    <br />
                    {{ item.x2 }}, {{ item.y2 }}
                  </div>
                </template>
                <template v-slot:item.created_at="{ item }">
                  <div class="ltr-text" v-if="$store.getters.LANGUAGE == 'fa'">
                    {{ item.created_at | moment("jYYYY/jM/jD HH:mm") }}
                  </div>
                  <div class="ltr-text" v-else>
                    {{ item.created_at | moment("YYYY/M/D HH:mm") }}
                  </div>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        small
                        color="error"
                        @click.stop="confirmDelete(item.id, item.name)"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="canDeleteError"
                      >
                        <v-icon small>fa-trash</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $vuetify.lang.translator("delete") }}</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-col>
            <v-col cols="12" lg="5" align-self="center" class="text-center">
              <div v-if="waitforFullSizeImage">
                <v-progress-circular
                  color="purple"
                  :value="downloadPercentage"
                  :size="100"
                  :width="15"
                  :rotate="-90"
                  >{{ downloadPercentage }}%
                </v-progress-circular>
              </div>
              <v-zoomer
                v-else
                style="width: 500px; height: 500px; border: solid 1px silver;"
              >
                <img
                  :src="fullSizeImage"
                  style="object-fit: contain; width: 100%; height: 100%;"
                />
              </v-zoomer>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="editorDialog"
      persistent
      max-width="1264"
      @keydown.esc="editorDialog = false"
    >
      <v-card>
        <v-toolbar>
          <v-toolbar-title>{{ fullSizeTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="editorDialog = false">
              <v-icon>fa-times</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container fluid>
          <v-row dense>
            <v-col cols="12" lg="6">
              <v-data-table
                fixed-header
                :header-props="{ sortIcon: 'fas fa-sort-amount-up-alt' }"
                :headers="headers"
                :items="items"
                :loading="loading"
                sort-by="updated_at"
                :sort-desc="true"
                :items-per-page="itemsPerPage"
                @update:items-per-page="updateRecordsPerPage"
                :footer-props="{ itemsPerPageOptions: [10, 25, 50, 100] }"
                :options.sync="options"
                :server-items-length="totalItems"
                :dense="showDense"
                :caption="$vuetify.lang.translator('errorsList')"
                class="elevation-2"
              >
                <template v-slot:item.index="{ item }">
                  {{
                    (options.page - 1) * options.itemsPerPage +
                      items.indexOf(item) +
                      1
                  }}
                </template>
                <template v-slot:item.x1="{ item }">
                  <div class="ltr-text">
                    {{ item.x1 }}, {{ item.y1 }}
                    <br />
                    {{ item.x2 }}, {{ item.y2 }}
                  </div>
                </template>
                <template v-slot:item.created_at="{ item }">
                  <div class="ltr-text" v-if="$store.getters.LANGUAGE == 'fa'">
                    {{ item.created_at | moment("jYYYY/jM/jD HH:mm") }}
                  </div>
                  <div class="ltr-text" v-else>
                    {{ item.created_at | moment("YYYY/M/D HH:mm") }}
                  </div>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        small
                        color="error"
                        @click.stop="confirmDelete(item.id, item.name)"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="canDeleteError"
                      >
                        <v-icon small>fa-trash</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $vuetify.lang.translator("delete") }}</span>
                  </v-tooltip>
                </template>
              </v-data-table>
              <v-form
                ref="newForm"
                v-model="newValid"
                @submit.prevent="tryCreate"
              >
                <v-card-title>
                  <span class="headline">{{
                    $vuetify.lang.translator("createNewError")
                  }}</span>
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="fields.name"
                        :label="$vuetify.lang.translator('name') + ' *'"
                        type="text"
                        autocomplete="on"
                        clearable
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-select
                        v-model="fields.error_type"
                        :label="$vuetify.lang.translator('type')"
                        :items="allErrorTypes"
                        item-text="name"
                        item-value="id"
                        :placeholder="
                          $vuetify.lang.translator('chooseAnOption')
                        "
                        clearable
                      ></v-select>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model.number="fields.x1"
                        label="X1"
                        type="number"
                        autocomplete="on"
                        clearable
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model.number="fields.y1"
                        label="Y1"
                        type="number"
                        autocomplete="on"
                        clearable
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model.number="fields.x2"
                        label="X2"
                        type="number"
                        autocomplete="on"
                        clearable
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model.number="fields.y2"
                        label="Y2"
                        type="number"
                        autocomplete="on"
                        clearable
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" type="submit" :disabled="waitForNew">
                    <v-icon class="mx-2">fa-save</v-icon
                    >{{ $vuetify.lang.translator("create") }}
                  </v-btn>
                </v-card-actions>
              </v-form>
              <v-form
                ref="importForm"
                v-model="importValid"
                @submit.prevent="tryImport"
              >
                <v-toolbar dense elevation="2">
                  <v-toolbar-title>{{
                    $vuetify.lang.translator("fromExcelFile")
                  }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn icon @click="importDialog = false">
                      <v-icon>fa-times</v-icon>
                    </v-btn>
                  </v-toolbar-items>
                </v-toolbar>
                <v-card-text>
                  <v-file-input
                    v-model="excelFile"
                    show-size
                    class="ltr-text mt-2"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    :label="$vuetify.lang.translator('selectExcelFile') + ' *'"
                  ></v-file-input>
                </v-card-text>
                <v-card-actions>
                  <v-btn color="primary" type="submit">
                    <v-icon class="mx-2">fa-upload</v-icon
                    >{{ $vuetify.lang.translator("create") }}
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-col>
            <v-col cols="12" lg="6" align-self="center" class="text-center">
              <div v-if="waitforFullSizeImage">
                <v-progress-circular
                  color="purple"
                  :value="downloadPercentage"
                  :size="100"
                  :width="15"
                  :rotate="-90"
                  >{{ downloadPercentage }}%
                </v-progress-circular>
              </div>
              <div v-else>
                <v-stage
                  :config="configKonva"
                  ref="stage"
                  @mousemove="handleMouseMove"
                  @mouseDown="handleMouseDown"
                  @mouseUp="handleMouseUp"
                >
                  <v-layer ref="layer">
                    <v-image
                      :config="{
                        x: 0,
                        y: 0,
                        image: image
                      }"
                    />
                    <v-rect
                      v-for="(rec, index) in recs"
                      :key="index"
                      :config="{
                        x: Math.min(
                          rec.startPointX,
                          rec.startPointX + rec.width
                        ),
                        y: Math.min(
                          rec.startPointY,
                          rec.startPointY + rec.height
                        ),
                        width: Math.abs(rec.width),
                        height: Math.abs(rec.height),
                        fill: 'rgb(0,0,0,0)',
                        stroke: 'black',
                        strokeWidth: 3
                      }"
                    />
                  </v-layer>
                </v-stage>
                <div style="position: absolute; top: 15px; left: 70px;">
                  <v-btn
                    ><v-icon @click="decreaseScale()">fa-minus</v-icon></v-btn
                  >
                  <v-btn
                    ><v-icon @click="increaseScale()">fa-plus</v-icon></v-btn
                  >
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteDialog"
      max-width="640px"
      persistent
      @keydown.esc="closeDelete"
    >
      <v-card>
        <v-card-title class="headline">{{ dialogTitle }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="closeDelete">{{
            $vuetify.lang.translator("no")
          }}</v-btn>
          <v-btn
            color="error"
            @click="tryDelete"
            :disabled="waitForDelete"
            :loading="waitForDelete"
            >{{ $vuetify.lang.translator("yes") }}</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="towerTypeDialog"
      persistent
      max-width="800"
      @keydown.esc="towerTypeDialog = false"
    >
      <v-card>
        <v-toolbar dense elevation="2">
          <v-toolbar-title>{{
            $vuetify.lang.translator("changeTowerType")
          }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="towerTypeDialog = false">
              <v-icon>fa-times</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-form
          ref="towerTypeForm"
          v-model="towerTypeForm"
          @submit.prevent="updateTowerType"
        >
          <v-card-text>
            <v-row>
              <v-col>
                <div>{{ $vuetify.lang.translator("selectTowerType") }}</div>
                <v-slide-group
                  show-arrows="always"
                  center-active
                  v-model="selectedTowerType"
                >
                  <v-slide-item
                    v-for="item in towerTypes"
                    :key="item"
                    v-slot="{ active, toggle }"
                  >
                    <v-card @click="toggle" class="ma-2">
                      <v-img :src="item"></v-img>
                      <v-overlay v-if="active" absolute>
                        <v-icon
                          v-if="active"
                          color="green"
                          size="48"
                          v-text="'fa-check'"
                        ></v-icon>
                      </v-overlay>
                    </v-card>
                  </v-slide-item>
                </v-slide-group>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" type="submit" :loading="waitForTowerType">
              <v-icon class="mx-2">fa-save</v-icon
              >{{ $vuetify.lang.translator("change") }}
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="towerTypeDialog = false"
              >{{ $vuetify.lang.translator("close") }}</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="towerDialog"
      persistent
      @keydown.esc="towerDialog = false"
      max-width="640"
    >
      <v-card>
        <v-form
          ref="towerForm"
          v-model="towerValid"
          @submit.prevent="updateTower"
        >
          <v-toolbar dense elevation="2">
            <v-toolbar-title>{{
              $vuetify.lang.translator("changeTowerView")
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn icon @click="towerDialog = false">
                <v-icon>fa-times</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-file-input
              v-model="towerFile"
              :rules="fileRules"
              show-size
              class="ltr-text mt-2"
              accept="image/jpeg"
              :label="$vuetify.lang.translator('selectJPGFile') + ' *'"
            ></v-file-input>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" type="submit" :disabled="waitForTower">
              <span class="mx-2" v-if="waitForTower"
                >{{ uploadPercentage }}%</span
              >
              <v-icon class="mx-2" v-else>fa-upload</v-icon
              >{{ $vuetify.lang.translator("send") }}
            </v-btn>
            <v-btn color="blue darken-1" text @click="closeTowerDialog">{{
              $vuetify.lang.translator("close")
            }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="helpDialog"
      persistent
      max-width="800"
      @keydown.esc="helpDialog = false"
      transition="dialog-top-transition"
    >
      <v-card>
        <v-toolbar dense elevation="2">
          <v-toolbar-title>{{
            $vuetify.lang.translator("help")
          }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="helpDialog = false">
              <v-icon>fa-times</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <div
            class="mt-6"
            v-html="$vuetify.lang.translator('adminImagesHelp')"
          ></div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="success" @click="helpDialog = false">{{
            $vuetify.lang.translator("gotIt")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { required, maxFileSize } from "@/helpers/validations";
import { handleError } from "@/helpers/helper";

export default {
  name: "AdminImages",
  data: () => ({
    breadcrumbsItems: [],
    helpDialog: false,
    showDense: true,
    batchID: 0,
    parents: [],
    imagesWithError: [],
    imagesWithNoError: [],
    open: [],
    active: [],
    search: null,
    fullSizeDialog: false,
    fullSizeImage: "",
    fullSizeTitle: "",
    waitforFullSizeImage: false,
    downloadPercentage: 0,
    uploadPercentage: 0,
    loading: false,
    loadingImages: false,
    loadingExtra: false,
    headers: [],
    items: [],
    itemsPerPage: 0,
    options: {},
    totalItems: 0,
    deleteDialog: false,
    dialogTitle: "",
    waitForDelete: false,
    idToBeDeleted: 0,
    imageID: 0,
    canDeleteError: false,
    tab: 0,
    showExtra: false,
    tower_image: null,
    tower_type_image: null,
    towerTypeDialog: false,
    towerTypes: [
      "/static/img/towers/tower0_t.jpg",
      "/static/img/towers/tower1_t.jpg",
      "/static/img/towers/tower2_t.jpg",
      "/static/img/towers/tower3_t.jpg",
      "/static/img/towers/tower4_t.jpg",
      "/static/img/towers/tower5_t.jpg",
      "/static/img/towers/tower6_t.jpg",
      "/static/img/towers/tower7_t.jpg",
      "/static/img/towers/tower8_t.jpg",
      "/static/img/towers/tower9_t.jpg",
      "/static/img/towers/tower10_t.jpg"
    ],
    selectedTowerType: null,
    towerTypeForm: false,
    waitForTowerType: false,
    selectedParent: null,
    towerDialog: false,
    towerValid: false,
    waitForTower: false,
    fileRules: [],
    towerFile: null,
    editorScale: 1.0,
    configKonva: {
      width: 600,
      height: 480
    },
    image: null,
    editorDialog: false,
    editorUser: "",
    recs: [],
    isDrawing: false,
    fields: {
      id: null,
      name: "",
      error_type: null,
      x1: null,
      y1: null,
      x2: null,
      y2: null
    },
    allErrorTypes: [],
    newValid: false,
    waitForNew: false,
    excelFile: null,
    importValid: false
  }),
  computed: {
    filter() {
      return (item, search, textKey) => item[textKey].indexOf(search) > -1;
    },
    selected() {
      if (!this.active.length) return undefined;
      let id = this.active[0];
      return id;
    }
  },
  watch: {
    selected: "showImages",
    open: function(newValue, oldValue) {
      if (newValue.length > oldValue.length) {
        this.selectedParent = newValue[newValue.length - 1];
        this.getExtra();
      }
    }
  },
  created() {
    this.showDense = this.$store.getters.SHOWDENSE === "show";
    this.batchID = this.$route.params.id;

    this.breadcrumbsItems.push({
      text: this.$vuetify.lang.translator("dashboard"),
      to: { name: "Dashboard" }
    });
    this.breadcrumbsItems.push({
      text: this.$vuetify.lang.translator("management")
    });
    this.breadcrumbsItems.push({
      text: this.$vuetify.lang.translator("uploadedImages"),
      to: { name: "AdminUploads" }
    });
    this.breadcrumbsItems.push({
      text: this.$vuetify.lang.translator("code") + " " + this.batchID
    });
    this.breadcrumbsItems.push({
      text: this.$vuetify.lang.translator("images"),
      to: {
        name: "AdminImages",
        params: { id: this.batchID }
      }
    });

    this.headers.push({
      text: this.$vuetify.lang.translator("row"),
      value: "index",
      sortable: false,
      align: "center"
    });
    this.headers.push({
      text: this.$vuetify.lang.translator("name"),
      value: "name"
    });
    this.headers.push({
      text: this.$vuetify.lang.translator("type"),
      value: "type_title"
    });
    this.headers.push({
      text: this.$vuetify.lang.translator("coordinates"),
      value: "x1",
      sortable: false
    });
    this.headers.push({
      text: this.$vuetify.lang.translator("operations"),
      value: "actions",
      sortable: false,
      align: "center"
    });

    this.allErrorTypes.push({
      id: 1,
      name: this.$vuetify.lang.translator("normal")
    });
    this.allErrorTypes.push({
      id: 2,
      name: this.$vuetify.lang.translator("warning")
    });
    this.allErrorTypes.push({
      id: 3,
      name: this.$vuetify.lang.translator("critical")
    });

    this.editorUser = this.$store.getters.NAME;
    this.checkPrivileges();
    this.getParents();
  },
  methods: {
    checkPrivileges() {
      let privileges = this.$store.getters.PRIVILEGES;
      this.canDeleteError = privileges.indexOf("2") === -1;
      let userType = parseInt(this.$store.getters.USERTYPE);
      let allowed_privileges = [1, 2];
      if (allowed_privileges.indexOf(userType) === -1) {
        this.$router.push({ name: "Error403" });
      }
    },
    getParents() {
      var self = this;
      this.$http
        .get("/batch/" + this.batchID + "/folder/0/")
        .then(function(response) {
          response.data.forEach(element => {
            let child = null;
            if (element.children_count === 0) {
              child = {
                id: element.id,
                name: element.name
              };
            } else {
              child = {
                id: element.id,
                name: element.name,
                children: []
              };
            }
            self.parents.push(child);
          });
        })
        .catch(function(error) {
          let result = handleError(
            error,
            self.$toasted,
            self.$router,
            self.$store
          );
          for (var item in result) {
            self.$toasted.error(result[item], {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          }
        });
    },
    async fetchChildren(item) {
      var self = this;
      return this.$http
        .get("/batch/" + this.batchID + "/folder/" + item.id + "/")
        .then(function(response) {
          response.data.forEach(element => {
            let child = null;
            if (element.children_count === 0) {
              child = {
                id: element.id,
                name: element.name
              };
            } else {
              child = {
                id: element.id,
                name: element.name,
                children: []
              };
            }
            item.children.push(child);
          });
        })
        .catch(function(error) {
          let result = handleError(
            error,
            self.$toasted,
            self.$router,
            self.$store
          );
          for (var item in result) {
            self.$toasted.error(result[item], {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          }
        });
    },
    showImages() {
      this.tab = 0;
      this.showImagesWithError();
      this.showImagesWithoutError();
    },
    showImagesWithError() {
      this.showExtra = false;
      this.loadingImages = true;
      this.imagesWithError = [];
      var self = this;
      this.$http
        .get("/folder/" + this.selected + "/image/errors/")
        .then(function(response) {
          response.data.forEach(element => {
            let image = {
              id: element.id,
              name: element.name,
              normal_count: element.normal_count,
              warning_count: element.warning_count,
              critical_count: element.critical_count
            };
            self.$http
              .get("/image/" + image.id + "/small/")
              .then(function(response) {
                let result = "data:image/jpg;base64,".concat(response.data);
                image.small = result;
                self.imagesWithError.push(image);
              })
              .catch(function(error) {
                let result = handleError(
                  error,
                  self.$toasted,
                  self.$router,
                  self.$store
                );
                for (var item in result) {
                  self.$toasted.error(result[item], {
                    duration: 5000,
                    keepOnHover: true,
                    className:
                      self.$store.getters.LANGUAGE == "fa"
                        ? "vazir-font-fd"
                        : "vazir-font",
                    iconPack: "fontawesome",
                    icon: "exclamation-triangle",
                    position: "top-center"
                  });
                }
              });
          });
        })
        .catch(function(error) {
          let result = handleError(
            error,
            self.$toasted,
            self.$router,
            self.$store
          );
          for (var item in result) {
            self.$toasted.error(result[item], {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          }
        })
        .then(function() {
          self.loadingImages = false;
        });
    },
    showImagesWithoutError() {
      this.showExtra = false;
      this.imagesWithNoError = [];
      var self = this;
      this.$http
        .get("/folder/" + this.selected + "/image/no-error/")
        .then(function(response) {
          response.data.forEach(element => {
            let image = {
              id: element.id,
              name: element.name,
              normal_count: element.normal_count,
              warning_count: element.warning_count,
              critical_count: element.critical_count
            };
            self.$http
              .get("/image/" + image.id + "/small/")
              .then(function(response) {
                let result = "data:image/jpg;base64,".concat(response.data);
                image.small = result;
                self.imagesWithNoError.push(image);
              })
              .catch(function(error) {
                let result = handleError(
                  error,
                  self.$toasted,
                  self.$router,
                  self.$store
                );
                for (var item in result) {
                  self.$toasted.error(result[item], {
                    duration: 5000,
                    keepOnHover: true,
                    className:
                      self.$store.getters.LANGUAGE == "fa"
                        ? "vazir-font-fd"
                        : "vazir-font",
                    iconPack: "fontawesome",
                    icon: "exclamation-triangle",
                    position: "top-center"
                  });
                }
              });
          });
        })
        .catch(function(error) {
          let result = handleError(
            error,
            self.$toasted,
            self.$router,
            self.$store
          );
          for (var item in result) {
            self.$toasted.error(result[item], {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          }
        });
    },
    showFullSize(name, id) {
      if (
        this.editorUser == "علی محمد حسین زاده" ||
        this.editorUser == "مهندس پیروحسینی" ||
        this.editorUser == "دکتر کرمی"
      ) {
        this.lunchEditor(name, id);
        this.fields.id = id;
      } else {
        this.lunchFullSize(name, id);
      }
    },
    lunchFullSize(name, id) {
      this.imageID = id;
      this.getErrors();
      this.waitforFullSizeImage = true;
      this.fullSizeTitle = this.$vuetify.lang.translator(
        "showImageFullsize",
        name
      );
      this.fullSizeDialog = true;
      this.downloadPercentage = 0;
      var self = this;
      this.$http
        .get("/image/" + id + "/big/", {
          onDownloadProgress: function(event) {
            self.downloadPercentage = Math.round(
              (event.loaded * 100) / event.total
            );
          }
        })
        .then(function(response) {
          let result = "data:image/jpg;base64,".concat(response.data);
          self.fullSizeImage = result;
        })
        .catch(function(error) {
          let result = handleError(
            error,
            self.$toasted,
            self.$router,
            self.$store
          );
          for (var item in result) {
            self.$toasted.error(result[item], {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          }
        })
        .then(function() {
          self.waitforFullSizeImage = false;
        });
    },
    lunchEditor(name, id) {
      this.imageID = id;
      this.getErrors();
      this.waitforFullSizeImage = true;
      this.fullSizeTitle = this.$vuetify.lang.translator(
        "showImageFullsize",
        name
      );
      this.editorDialog = true;
      this.downloadPercentage = 0;
      var self = this;
      this.$http
        .get("/image/" + id + "/big/", {
          onDownloadProgress: function(event) {
            self.downloadPercentage = Math.round(
              (event.loaded * 100) / event.total
            );
          }
        })
        .then(function(response) {
          let result = "data:image/jpg;base64,".concat(response.data);
          const image = new window.Image();
          image.src = result;
          image.onload = () => {
            self.image = image;
          };
        })
        .catch(function(error) {
          let result = handleError(
            error,
            self.$toasted,
            self.$router,
            self.$store
          );
          for (var item in result) {
            self.$toasted.error(result[item], {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          }
        })
        .then(function() {
          self.waitforFullSizeImage = false;
        });
    },
    getErrors() {
      this.loading = true;
      var parameters = null;
      var self = this;
      this.$http
        .get("/image/" + this.imageID + "/error/", {
          params: parameters
        })
        .then(function(response) {
          self.items = response.data.results;
          self.totalItems = response.data.count;
        })
        .catch(function(error) {
          let result = handleError(
            error,
            self.$toasted,
            self.$router,
            self.$store
          );
          for (var item in result) {
            self.$toasted.error(result[item], {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          }
        })
        .then(function() {
          self.loading = false;
        });
    },
    confirmDelete(id, name) {
      this.idToBeDeleted = id;
      this.dialogTitle = this.$vuetify.lang.translator(
        "sureToDeleteError",
        name
      );
      this.deleteDialog = true;
    },
    tryDelete() {
      if (this.idToBeDeleted === 0) {
        this.$toasted.error(this.$vuetify.lang.translator("selectAnError"), {
          duration: 5000,
          keepOnHover: true,
          className:
            self.$store.getters.LANGUAGE == "fa"
              ? "vazir-font-fd"
              : "vazir-font",
          iconPack: "fontawesome",
          icon: "exclamation-triangle",
          position: "top-center"
        });
        return;
      }
      this.waitForDelete = true;
      let self = this;
      self.$http
        .delete("/error/" + this.idToBeDeleted + "/")
        .then(() => {
          self.$toasted.success(
            self.$vuetify.lang.translator("errorDeletedQueue"),
            {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "check",
              position: "top-center"
            }
          );
          self.getErrors();
          self.deleteDialog = false;
        })
        .catch(error => {
          let result = handleError(
            error,
            self.$toasted,
            self.$router,
            self.$store
          );
          for (var item in result) {
            self.$toasted.error(result[item], {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          }
        })
        .then(function() {
          self.waitForDelete = false;
        });
    },
    closeDelete() {
      this.idToBeDeleted = 0;
      this.deleteDialog = false;
    },
    getExtra() {
      this.showExtra = true;
      this.loadingExtra = true;
      this.tower_image = null;
      this.tower_type_image = null;
      var self = this;
      this.$http
        .get("/folder/" + this.selectedParent + "/extra/")
        .then(function(response) {
          if (response.data.tower !== "") {
            self.tower_image = "data:image/jpg;base64,".concat(
              response.data.tower
            );
          }
          if (response.data.tower_type !== "") {
            self.tower_type_image = "data:image/jpg;base64,".concat(
              response.data.tower_type
            );
          }
        })
        .catch(function(error) {
          let result = handleError(
            error,
            self.$toasted,
            self.$router,
            self.$store
          );
          for (var item in result) {
            self.$toasted.error(result[item], {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          }
        })
        .then(function() {
          self.loadingExtra = false;
        });
    },
    openChangeTowerType() {
      this.selectedTowerType = null;
      this.towerTypeDialog = true;
    },
    updateTowerType() {
      if (
        this.selectedTowerType === null ||
        this.selectedTowerType === undefined
      ) {
        this.$toasted.error(this.$vuetify.lang.translator("selectTowerType"), {
          duration: 5000,
          keepOnHover: true,
          className:
            self.$store.getters.LANGUAGE == "fa"
              ? "vazir-font-fd"
              : "vazir-font",
          iconPack: "fontawesome",
          icon: "exclamation-triangle",
          position: "top-center"
        });
        return;
      }
      let self = this;
      setTimeout(function() {
        if (self.$refs.towerTypeForm.validate()) {
          self.waitForTowerType = true;
          self.$http
            .get(
              "/folder/" +
                self.selectedParent +
                "/type/" +
                self.selectedTowerType +
                "/"
            )
            .then(() => {
              self.$toasted.success(
                self.$vuetify.lang.translator("towerTypeEdited"),
                {
                  duration: 5000,
                  keepOnHover: true,
                  className:
                    self.$store.getters.LANGUAGE == "fa"
                      ? "vazir-font-fd"
                      : "vazir-font",
                  iconPack: "fontawesome",
                  icon: "check",
                  position: "top-center"
                }
              );
              self.getExtra();
              self.towerTypeDialog = false;
            })
            .catch(error => {
              let result = handleError(
                error,
                self.$toasted,
                self.$router,
                self.$store
              );
              for (var item in result) {
                self.$toasted.error(result[item], {
                  duration: 5000,
                  keepOnHover: true,
                  className:
                    self.$store.getters.LANGUAGE == "fa"
                      ? "vazir-font-fd"
                      : "vazir-font",
                  iconPack: "fontawesome",
                  icon: "exclamation-triangle",
                  position: "top-center"
                });
              }
            })
            .then(function() {
              self.waitForTowerType = false;
            });
        }
      });
    },
    updateTower() {
      this.fileRules = [
        required(this.$vuetify.lang.translator("file"), this.$vuetify),
        maxFileSize(
          10000000,
          this.$vuetify.lang.translator("file"),
          this.$vuetify
        )
      ];
      let self = this;
      setTimeout(function() {
        if (self.$refs.towerForm.validate()) {
          self.waitForTower = true;
          var formData = new FormData();
          formData.append("original_file", self.towerFile);
          formData.append("id", self.selectedParent);
          self.$http
            .post("/folder/", formData, {
              headers: { "Content-Type": "multipart/form-data" },
              onUploadProgress: function(event) {
                self.uploadPercentage = Math.round(
                  (event.loaded * 100) / event.total
                );
              }
            })
            .then(() => {
              self.$toasted.success(
                self.$vuetify.lang.translator("fileUploaded"),
                {
                  duration: 5000,
                  keepOnHover: true,
                  className:
                    self.$store.getters.LANGUAGE == "fa"
                      ? "vazir-font-fd"
                      : "vazir-font",
                  iconPack: "fontawesome",
                  icon: "check",
                  position: "top-center"
                }
              );
              self.getExtra();
              self.closeTowerDialog();
            })
            .catch(error => {
              let result = handleError(error, self.$toasted, self.$router);
              for (var item in result) {
                self.$toasted.error(result[item], {
                  duration: 5000,
                  keepOnHover: true,
                  className:
                    self.$store.getters.LANGUAGE == "fa"
                      ? "vazir-font-fd"
                      : "vazir-font",
                  iconPack: "fontawesome",
                  icon: "exclamation-triangle",
                  position: "top-center"
                });
              }
            })
            .then(function() {
              self.waitForTower = false;
            });
        }
      });
    },
    closeTowerDialog() {
      this.fileRules = [];
      this.uploadPercentage = 0;
      this.towerFile = null;
      this.towerDialog = false;
    },
    increaseScale() {
      this.editorScale *= 2;
      console.log(this.editorScale);
      this.$refs.stage
        .getNode()
        .scale({ x: this.editorScale, y: this.editorScale });
    },
    decreaseScale() {
      this.editorScale /= 2;
      console.log(this.editorScale);
      this.$refs.stage
        .getNode()
        .scale({ x: this.editorScale, y: this.editorScale });
    },
    handleMouseDown() {
      this.isDrawing = true;
      const pos = this.$refs.stage.getNode().getPointerPosition();
      this.setRecs([
        ...this.recs,
        { startPointX: pos.x, startPointY: pos.y, width: 0, height: 0 }
      ]);
    },
    handleMouseUp() {
      this.isDrawing = false;
    },
    setRecs(element) {
      this.recs = element;
    },
    handleMouseMove() {
      // no drawing - skipping
      if (!this.isDrawing) {
        return;
      }
      // console.log(event);
      const point = this.$refs.stage.getNode().getPointerPosition();
      // handle  rectangle part
      let curRec = this.recs[this.recs.length - 1];
      curRec.width = point.x - curRec.startPointX;
      curRec.height = point.y - curRec.startPointY;
    },
    tryCreate() {
      let self = this;
      setTimeout(function() {
        if (self.$refs.newForm.validate()) {
          self.waitForNew = true;
          self.$http
            .post("/new-error/", self.fields)
            .then(() => {
              self.$toasted.success(
                self.$vuetify.lang.translator("newErrorCreated"),
                {
                  duration: 5000,
                  keepOnHover: true,
                  className:
                    self.$store.getters.LANGUAGE == "fa"
                      ? "vazir-font-fd"
                      : "vazir-font",
                  iconPack: "fontawesome",
                  icon: "check",
                  position: "top-center"
                }
              );
              self.fields.name = "";
              self.fields.error_type = null;
              self.fields.x1 = null;
              self.fields.y1 = null;
              self.fields.x2 = null;
              self.fields.y2 = null;
              self.getErrors();
            })
            .catch(error => {
              let result = handleError(
                error,
                self.$toasted,
                self.$router,
                self.$store
              );
              for (var item in result) {
                self.$toasted.error(result[item], {
                  duration: 5000,
                  keepOnHover: true,
                  className:
                    self.$store.getters.LANGUAGE == "fa"
                      ? "vazir-font-fd"
                      : "vazir-font",
                  iconPack: "fontawesome",
                  icon: "exclamation-triangle",
                  position: "top-center"
                });
              }
            })
            .then(function() {
              self.waitForNew = false;
            });
        }
      });
    },
    tryImport() {
      let self = this;
      setTimeout(function() {
        if (self.$refs.importForm.validate()) {
          self.waitForImport = true;
          var formData = new FormData();
          formData.append("excel_file", self.excelFile);
          self.$http
            .post("/batch/" + self.batchID + "/import-errors/", formData, {
              headers: { "Content-Type": "multipart/form-data" }
            })
            .then(() => {
              self.$toasted.success(
                self.$vuetify.lang.translator("fileUploadedErrorsCreated"),
                {
                  duration: 5000,
                  keepOnHover: true,
                  className:
                    self.$store.getters.LANGUAGE == "fa"
                      ? "vazir-font-fd"
                      : "vazir-font",
                  iconPack: "fontawesome",
                  icon: "check",
                  position: "top-center"
                }
              );
              self.excelFile = null;
            })
            .catch(error => {
              let result = handleError(error, self.$toasted, self.$router);
              for (var item in result) {
                self.$toasted.error(result[item], {
                  duration: 5000,
                  keepOnHover: true,
                  className:
                    self.$store.getters.LANGUAGE == "fa"
                      ? "vazir-font-fd"
                      : "vazir-font",
                  iconPack: "fontawesome",
                  icon: "exclamation-triangle",
                  position: "top-center"
                });
              }
            })
            .then(function() {
              self.waitForImport = false;
            });
        }
      });
    },
    updateRecordsPerPage(rowsPerPage) {
      this.$store.dispatch("saveRecordsPerPage", rowsPerPage);
    }
  }
};
</script>
